module.exports = __webpack_public_path__ + "lp/img/up-icon-technicalproblem.2d51f517.svg";